import { useSelector } from 'react-redux';

import { useRouter } from 'next/router';

import useIsMeetingDetailsView from '@hooks/useIsMeetingDetailsView';
import useIsMinutesEditorView from '@hooks/useIsMinutesEditorView';

import { getCurrentAppSection } from '@redux/selectors/AppSelector';

import { NEW_MEETING_UUID } from '@meetings/details/details.constants';

const useMeetingIdFromRoute = () => {
    const router = useRouter();
    const currentSection = useSelector(getCurrentAppSection);
    const { isViewModeDetailsView } = useIsMeetingDetailsView(currentSection);
    const { isMinutesEditorViewMode } = useIsMinutesEditorView();

    if (router.query.meetingId) {
        return router.query.meetingId as string;
    }
    const meetingId =
        isViewModeDetailsView || isMinutesEditorViewMode
            ? router.query.uuid
            : router.query.slug?.[0];
    return router.query.slug?.[0] === NEW_MEETING_UUID ? '' : (meetingId as string);
};

export default useMeetingIdFromRoute;
